import { useMutation } from '@tanstack/react-query';
import { api } from '../../services/api';

export const useUploadPetPhoto = () => {
  return useMutation({
    mutationFn: async ({ petId, file }: { petId: string; file: File }) => {
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.post<{ photoUrl: string }>(`/pets/${petId}/photo`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });

      return response.data.photoUrl;
    },
  });
};
